import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';

type Props = {
  onValueChange: (value: string) => void;
  value: string;
};

const ROLES = ['collector', 'supervisor'];

const RolesDropdown: React.FC<Props> = ({ onValueChange, value }) => {
  return (
    <Select onValueChange={onValueChange} defaultValue={value}>
      <SelectTrigger className='h-[44px] font-normal flex justify-between w-full rounded-[5px] border border-[#C9C9C9] bg-white px-3 py-1 text-sm shadow-sm transition-colors placeholder:text-muted-foreground/50   disabled:cursor-not-allowed disabled:opacity-50 '>
        {value ? value : <span className='text-[#C9C9C9]'>Role</span>}
      </SelectTrigger>
      <SelectContent>
        {ROLES.map((role) => (
          <SelectItem key={role} value={role}>
            {role}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};

export default RolesDropdown;
